/* Preproduction purchase continuity. Delegate to Shopify, never construct another cart request. */
(function () {
  'use strict';
  var bar = document.getElementById('afich-sticky-atc');
  var info = document.querySelector('.product__info-container');
  if (!bar || !info || bar.dataset.ready) return;
  bar.dataset.ready = '1';
  var button = bar.querySelector('.afich-sticky-btn'), price = bar.querySelector('.afich-sticky-price');
  var options = bar.querySelector('.afich-purchase-options'), status = bar.querySelector('.afich-purchase-status');
  var feedback = bar.querySelector('.afich-purchase-feedback');
  var pendingFrame = 0, preview = null;
  info.classList.add('afich-purchase-info'); document.documentElement.classList.add('afich-purchase-ready');
  function real() { return info.querySelector('product-form .product-form__submit') || info.querySelector('.product-form__submit'); }
  function visible(el) {
    if (!el || el.hidden) return false;
    // Theme modals keep their geometry while a parent is transparent or a details element is closed.
    if (el.checkVisibility && !el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return false;
    if (el.closest('details:not([open])') && !el.closest('summary')) return false;
    var r = el.getBoundingClientRect(), s = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth && s.display !== 'none' && s.visibility !== 'hidden';
  }
  function blocked() {
    if (document.querySelector('#afp2-ov,cart-drawer.active,cart-notification.active,.menu-drawer-container[open]')) return true;
    return Array.from(document.querySelectorAll('[aria-modal="true"],dialog[open],.shopify-pc__banner__dialog')).some(visible);
  }
  function setText(node, text) { if (node.textContent !== text) node.textContent = text; }
  function nativeDisabled(r) { return !r || r.disabled || r.getAttribute('aria-disabled') === 'true'; }
  function prepareLayout() {
    // Old custom-liquid blocks containing only scripts/styles still reserve margins above the CTA.
    Array.from(info.children).forEach(function (el) {
      if (!el.classList.contains('custom-liquid')) return;
      var content = Array.from(el.childNodes).some(function (n) {
        return n.nodeType === 3 ? Boolean(n.textContent.trim()) : n.nodeType === 1 && !['SCRIPT', 'STYLE'].includes(n.tagName);
      });
      el.classList.toggle('afich-purchase-empty', !content);
    });
  }
  function previewOffset() {
    var next = document.getElementById('PBarNextFrameWrapper');
    if (next !== preview) { if (preview) resize.unobserve(preview); preview = next; if (preview) { resize.observe(preview); previewChanges.observe(preview, { attributes: true, subtree: true, attributeFilter: ['style', 'class', 'hidden'] }); } }
    if (!visible(preview)) return 0;
    var r = preview.getBoundingClientRect();
    return r.bottom >= innerHeight - 2 && r.width > innerWidth / 2 ? Math.max(0, Math.ceil(innerHeight - r.top)) : 0;
  }
  function sync() {
    pendingFrame = 0; prepareLayout();
    var r = real();
    if (!r) { bar.hidden = true; return; }
    var offset = previewOffset();
    document.documentElement.style.setProperty('--afich-preview-offset', offset + 'px');
    var p = info.querySelector('.price');
    var amount = p && (p.querySelector(p.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular') || p.querySelector('.price-item--regular'));
    setText(price, amount ? amount.textContent.trim().replace(/\s+/g, ' ') : '');
    var selected = Array.from(info.querySelectorAll('variant-radios input:checked,variant-selects select')).map(function (input) { return input.value; }).filter(Boolean);
    setText(options, selected.join(' · '));
    var busy = r.classList.contains('loading');
    var label = (r.innerText || r.textContent || '').trim().replace(/\s+/g, ' ');
    setText(button, busy ? 'Ajout en cours…' : label || 'Ajouter au panier');
    button.disabled = nativeDisabled(r); button.setAttribute('aria-busy', String(busy));
    setText(status, busy ? 'Ajout de votre affiche au panier…' : '');
    var error = info.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
    var errorText = error ? error.textContent.trim() : '';
    setText(feedback, errorText); if (feedback.hidden !== !errorText) feedback.hidden = !errorText;
    var rect = r.getBoundingClientRect(), header = document.querySelector('.shopify-section-header');
    var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    var hit = rect.width && rect.height ? document.elementFromPoint(rect.left + rect.width / 2, rect.top + rect.height / 2) : null;
    var nativeVisible = rect.width > 0 && rect.height > 0 && rect.top >= top && rect.bottom <= innerHeight - offset - 8 && (hit === r || r.contains(hit));
    var typing = innerWidth < 750 && document.activeElement && document.activeElement.matches('input[type=email],input[type=text],input[type=search],textarea,[contenteditable=true]');
    // The bar itself must not make the native button look occluded and prevent it from disappearing.
    if (hit && bar.contains(hit) && rect.top >= top && rect.bottom <= innerHeight - offset - 8) nativeVisible = true;
    var hide = nativeVisible || blocked() || typing;
    if (bar.hidden !== Boolean(hide)) bar.hidden = Boolean(hide);
    document.documentElement.style.setProperty('--afich-purchase-space', bar.hidden ? '0px' : (Math.ceil(bar.getBoundingClientRect().height) + offset) + 'px');
  }
  function schedule() { if (!pendingFrame) pendingFrame = requestAnimationFrame(sync); }
  button.addEventListener('click', function () {
    var r = real(); if (nativeDisabled(r) || blocked()) return;
    r.click(); sync();
  });
  options.addEventListener('click', function () {
    var picker = info.querySelector('variant-radios,variant-selects,.product-parameters');
    if (!picker) return;
    picker.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    var selected = picker.querySelector('input:checked') || picker.querySelector('select,input');
    if (selected) selected.focus({ preventScroll: true });
  });
  var resize = new ResizeObserver(schedule), previewChanges = new MutationObserver(schedule);
  resize.observe(info); resize.observe(bar);
  var changes = new MutationObserver(function (records) {
    if (records.some(function (m) { return !bar.contains(m.target); })) schedule();
  });
  changes.observe(document.body, { childList: true, subtree: true, attributes: true, characterData: true, attributeFilter: ['class', 'style', 'open', 'hidden', 'disabled', 'aria-disabled', 'inert'] });
  ['scroll', 'resize', 'orientationchange'].forEach(function (event) { window.addEventListener(event, schedule, { passive: true }); });
  ['change', 'focusin', 'focusout', 'shopify:section:load'].forEach(function (event) { document.addEventListener(event, schedule); });
  if (window.visualViewport) { visualViewport.addEventListener('resize', schedule); visualViewport.addEventListener('scroll', schedule); }
  if (document.fonts) document.fonts.ready.then(schedule);
  sync();
})();
